import React from 'react';
import Lottie from 'lottie-react';
import animationData from './AnimationLoader.json';

const AnimatedLoader = () => {
  return (
    <>
      <Lottie animationData={animationData} loop={true} />
    </>
  );
};

export default AnimatedLoader;
